import { render, staticRenderFns } from "./SalesAI.vue?vue&type=template&id=606bd182"
import script from "./SalesAI.vue?vue&type=script&lang=js"
export * from "./SalesAI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports